import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { ErrorBoundary } from "react-error-boundary";

import { Button } from "@progress/kendo-react-buttons";

export default function ErrorPanel(props) {
    
	const navigate = useNavigate();
	const location = useLocation();
  	
  	const fallbackRender = ({ error, resetErrorBoundary }) => {
		console.error(error);
		
		if (redirect && location.pathname.substring(1) != "") {
			redirectToHome();
		}
		  
		return (
 			<div className="constituo-error-container" role="error">
				<div className="constituo-error-box">
					<div className="constituo-error-icon-container">
						<span className="fa fa-fw fa-attention"/>
					</div>
					<div className="constituo-error-text-container">
						<div className="constituo-error-message">
							<div>
								<span>{msg}</span>
							</div>
							{tryAgain && (
								<div style={{ marginTop: "10px" }}>
									<Button
										key="refresh-btn"
										iconClass="fa fa-fw fa-small fa-cw"
										title={"Try Again"}
										onClick={() => resetErrorBoundary()}
									>
										{"Try Again"}
									</Button>
								</div>
	                        )} 
						</div>
					</div>
				</div>
			</div>
		);   	     
	};
	
	const refresh = () => {
		navigate(0);
    };
	    
    const { 
        msg = "An error has occurred.  If this problem persists, please contact Support.", 
        tryAgain = true,
        onReset = refresh,
        redirect = false,
	} = props;
	
	const redirectToHome = () => {
		const url = window.location.origin + '/constituo/';
		window.location = url;
	};
	
	return (
		<ErrorBoundary
  			fallbackRender={fallbackRender}
  			onReset={(details) => onReset(details)}
		>
			{props.children}
		</ErrorBoundary>
    );
}